import { IBrushSettings } from "../../../../../../models/brush";

export const DEFAULT_BRUSH: IBrushSettings = Object.freeze({
	lineJoin: "round",
	lineCap: "round",
	strokeStyle: "#8800FF",
	lineWidth: 60,
	globalCompositeOperation: "source-over",
	globalAlpha: 1,
	brushColorOpacity: 1,
	reset: false,
	brushMode: "brush",
});

export enum SegmentationMaskTypes {
	AUTOMATIC = "automatic",
	MANUAL = "manual",
}

export const OBJECT_MANIPULATION_CONFIGS = Object.freeze({
	prompt: "",
	tailored_model_id: "",
	tailored_model_version: "",
	num_results: 4,
	erase: false,
	gen_fill: false,
	mask_type: SegmentationMaskTypes.MANUAL,
});
